import { cartLineQuantityStyles as styles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.readOnlyQuantityText = {};
